export const PAGE_QUERY_PARAM_NAME = 'page'
export const DEFAULT_PAGE = 1

export const DEFAULT_PAGE_SIZE = 50
export const DEFAULT_VISIBLE_PAGES_LIMIT = 5
